

























































import { Component } from 'vue-property-decorator';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductIssueDetails from '@/components/Products/ProductIssues/ProductIssueDetails.vue';
import ProductIssueAccounts from '@/components/Products/ProductIssues/ProductIssueAccounts.vue';
import ProductSettingsTabs from '@/components/Products/ProductSettings/ProductSettingsTabs.vue';
import ProductFees from '@/components/Products/Product/ProductFees.vue';
import EntityType from '@/models/Shared/EntityType';
import History from '@/components/Shared/History.vue';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'ProductIssue', components: { Alert, ProductIssueDetails, ProductIssueAccounts, ProductSettingsTabs, ProductFees, History }, metaInfo: { title: 'Product Issues' } })
export default class extends SaascadaVue {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await ProductIssueDetailsModule.getProductIssue(this.$route.params.id);
    }

    get productIssue() {
        return ProductIssueDetailsModule.productIssue;
    }

    get loading() {
        return ProductIssueDetailsModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
